import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import styled from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageSectionHeading from '../../PageSectionHeading';
// import { colors } from '../../../styles';

const styles = ({ content }) => `
  padding:90px 0;
  .EmbedSection {
    padding:40px 0;
    display:flex;
    flex-flow:column wrap;
    justify-content:center;
  }
  .EmbedSection_textBlock {
    padding:40px 20px;
  }
  .frame {
    min-height:300px;
    ${
      orderBy(get(content, '[0].frame_breakpoints', []), 'breakpoint', 'asc').map(setting => (`
        @media (min-width: ${get(setting, 'breakpoint')}px) {
          height: ${get(setting, 'frame_height')}px;
        }
      `)).join('\n')
    }
  }
`;

function EmbedSection({ content, className }) {
  return (
    <div>
      {
        get(content, '[0].embed_url') &&
        <div className={className}>
          {
            get(content, '[0].section_heading') &&
            <PageSectionHeading h3={get(content, '[0].section_heading')} />
          }
          <div className="container">
            <div className="row EmbedSection">
              <div className="col-lg-8 mx-lg-auto p-0">
                {
                  get(content, '[0].text_block') &&
                  <div className="EmbedSection_textBlock" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].text_block'))} />
                }
                {
                  get(content, '[0].embed_url') &&
                  <div>
                    <iframe
                      className="frame"
                      title="Pricing"
                      frameBorder="0"
                      src={get(content, '[0].embed_url')}
                      width="100%"
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

EmbedSection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
};

EmbedSection.defaultProps = {
  className: undefined,
};

export default styled(EmbedSection)(styles);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/EmbedSection.section.js